/** @type {import('node_modules/vue-router/types/index').RouteConfig[]} */
import i18n from '@/i18n/i18n'
import { faCalendarAlt, faSearch } from '@fortawesome/free-solid-svg-icons'
import { pickupsGuard, pickupsGuardUpgrade } from '@/router/guards/pickups-guard.js'

export const PICKUPS_ROUTE = 'pickups'
export const PICKUPS_ARCHIVE_SCHEDULED_ROUTE = 'pickups-archive-scheduled'
export const PICKUPS_ARCHIVE_HISTORY_ROUTE = 'pickups-archive-history'
export const PICKUPS_ARCHIVE_CANCELLED_ROUTE = 'pickups-archive-cancelled'
export const PICKUPS_SCHEDULE_ROUTE = 'pickups-schedule'
export const PICKUPS_SCHEDULE_WIZARD_ROUTE = 'pickups-schedule-wizard'
export const PICKUPS_SCHEDULE_RECURRING_ROUTE = 'pickups-schedule-recurring'
export const PICKUPS_FEATURE_TEASER = 'pickups-feature-teaser'

const viewRequestedPickupsBtn = {
  title: () => i18n.t('View requested pickups'),
  name: PICKUPS_ARCHIVE_SCHEDULED_ROUTE,
  mode: 'primary',
  icon: faSearch,
}
const requestPickupBtn = {
  title: () => i18n.t('Request a pickup'),
  icon: faCalendarAlt,
  mode: 'primary',
  name: PICKUPS_SCHEDULE_WIZARD_ROUTE,
  dataTest: 'request-a-pickup-button',
}
export default [
  {
    name: PICKUPS_ROUTE,
    path: '/pickups',
    beforeEnter: pickupsGuard,
    component: () => import('@/app/pickups/views/PickupsListNav.vue'),
    redirect: { name: PICKUPS_ARCHIVE_SCHEDULED_ROUTE },
    meta: {
      pageTitle: () => i18n.t('Pickups'),
      permissions: ['manage_pickups'],
    },
    children: [
      {
        name: PICKUPS_ARCHIVE_SCHEDULED_ROUTE,
        path: '/pickups/archive/scheduled',
        component: () => import('@/app/pickups/views/PickupsListScheduled.vue'),
        meta: {
          pageTitle: () => i18n.t('Scheduled pickups'),
          permissions: ['manage_pickups'],
          buttons: [requestPickupBtn],
        },
      },
      {
        name: PICKUPS_ARCHIVE_HISTORY_ROUTE,
        path: '/pickups/archive/archive',
        component: () => import('@/app/pickups/views/PickupsListArchived.vue'),
        meta: {
          pageTitle: () => i18n.t('Pickup archive'),
          permissions: ['manage_pickups'],
          buttons: [requestPickupBtn],
        },
      },
      {
        name: PICKUPS_ARCHIVE_CANCELLED_ROUTE,
        path: '/pickups/archive/cancelled',
        component: () => import('@/app/pickups/views/PickupsListCancelled.vue'),
        meta: {
          pageTitle: () => i18n.t('Cancelled pickups'),
          permissions: ['manage_pickups'],
          buttons: [requestPickupBtn],
        },
      },
    ],
  },
  {
    name: PICKUPS_SCHEDULE_ROUTE,
    path: '/pickups/schedule',
    beforeEnter: pickupsGuard,
    redirect: { name: PICKUPS_SCHEDULE_WIZARD_ROUTE },
    component: () => import('@/app/pickups/views/PickupRequestView.vue'),
    meta: {
      pageTitle: () => i18n.t('Request a pickup'),
      permissions: ['manage_pickups'],
    },
    children: [
      {
        name: PICKUPS_SCHEDULE_WIZARD_ROUTE,
        path: '/pickups/schedule/wizard',
        component: () => import('@/app/pickups/views/PickupRequestForm.vue'),
        meta: {
          pageTitle: () => i18n.t('Request a pickup'),
          permissions: ['manage_pickups'],
          buttons: [viewRequestedPickupsBtn],
        },
      },
      {
        name: PICKUPS_SCHEDULE_RECURRING_ROUTE,
        path: '/pickups/schedule/recurring',
        component: () => import('@/app/pickups/views/RecurringPickupRequestForm.vue'),
        meta: {
          pageTitle: () => i18n.t('Request a pickup'),
          permissions: ['manage_pickups'],
          buttons: [viewRequestedPickupsBtn],
        },
      },
    ],
  },
  {
    name: PICKUPS_FEATURE_TEASER,
    path: '/pickups/upgrade-your-plan',
    beforeEnter: pickupsGuardUpgrade,
    component: () => import('@/app/pickups/views/PickupsFeatureTeaser.vue'),
    meta: {
      pageTitle: () => i18n.t('Pickups'),
      permissions: ['manage_pickups'],
    },
  },
]
